module.exports = __webpack_public_path__ + "media/images/area/feature/chubu/related/zh-hant/3-d72dad0410a6461dab6495b92705d901.jpg";